import { Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useToast, useModal } from "@/comn/hooks";
import { comnEnvs } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { APIS, SF_COMN_CD_MGMT_DTL_INFO, URLS } from "./services/PtliComnCdAppService";

/*
 * Common Code Valid Value Details
 * !== 공통 코드 유효 값 상세 ==!
 */
export const PTLI0404007Q = (props: any) => {
    const pgeUid = "UI-PTLI-0404-007Q";
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const toast = useToast();
    const { comnCd, cdVldVal } = useParams();

    const form = {
        comnCdMgmtDtlInfo: useForm({
            defaultSchema: SF_COMN_CD_MGMT_DTL_INFO,
        }),
    };

    const fetch = {
        // Check common code valid value information !== 공통 코드 유효 값 정보 조회 ==!
        getComnCdDtlInfo: useFetch({
            api: (data: any) => APIS.getComnCdDtlInfo(data),
            enabled: false,
            onSuccess: (data) => {
                const comnCdMgmtDtlInfo = data.comnCdDtl.content;
                form.comnCdMgmtDtlInfo.setValues(comnCdMgmtDtlInfo);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Delete Common Code Valid Values !== 공통 코드 유효 값 삭제 ==!
        deleteComnCdDtl: useFetch({
            api: () => APIS.deleteComnCdDtl(comnCd, cdVldVal),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        modal.postMessage({ pgeUid: pgeUid });
                    },
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00023" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    const handler = {
        // Check common code valid value information !== 공통 코드 유효 값 정보 조회 ==!
        getComnCdDtlInfo: () => {
            const data = form.comnCdMgmtDtlInfo.getValues();
            fetch.getComnCdDtlInfo.fetch(data);
        },
        // Click the Modify button !== 수정 버튼 클릭 ==!
        click_Btn_Edit: () => {
            navigate(URLS.ptli0404008s + "/" + comnCd + "/" + cdVldVal + "?ppup=Y");
        },
        // Delete Common Code Valid Values !== 공통 코드 유효 값 삭제 ==!
        deleteComnCdDtl: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteComnCdDtl.fetch();
                },
            });
        },
    };

    useEffect(() => {
        form.comnCdMgmtDtlInfo.setValue("comnCd", comnCd);
        form.comnCdMgmtDtlInfo.setValue("cdVldVal", cdVldVal);
        form.comnCdMgmtDtlInfo.setEditable(false);
        handler.getComnCdDtlInfo();
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_COMN_CD_DTL_DTL")}
            navigation={{
                base: comnEnvs.base,
                nodes: [
                    { label: "Portal" },
                    { label: "Common Module" },
                    { label: "Code Management" },
                    { path: "/comnmdle/comncd/ptli0404001q", label: "Common Code Management" },
                ],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.comnCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldVal} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmEn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmTz} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.cdVldValNmKo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.useYn} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldStrtDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.vldEndDt} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.srtngOrd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal1} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal2} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnCdMgmtDtlInfo.schema.usrDefnVldVal3} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Section>
                        <Layout>
                            <Layout.Right>
                                <Layout.Button
                                    role={"edit"}
                                    onClick={() => {
                                        handler.click_Btn_Edit();
                                    }}
                                />
                                <Layout.Button
                                    role={"delete"}
                                    onClick={() => {
                                        handler.deleteComnCdDtl();
                                    }}
                                />
                            </Layout.Right>
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
